import React from 'react'
import PropTypes from 'prop-types'

const SectionTwo = (props) => {
    const {handleButtonClick ,setSelectedOptions ,selectedOptions,toggleOption ,setMessageBoard,setErrorTabEnable} = props
  return (
    <div>
    <div className="error-message-head1">Check The Account Status</div>
    <div className="error-message-head2">
      Check the account status in Seibel
    </div>
    <div style={{ gap: "8px", display: "flex", marginTop: "22px" }}>
      <button
        onClick={() => {
          handleButtonClick(2, "active");
          setSelectedOptions([
            true,
            true,
            true,
            false,
            false,
            false,
            false,
          ]);
        }}
        disabled={selectedOptions[2]}
        className={`error-button ${
          toggleOption[2] === "active" ? "clicked" : ""
        }`}
      >
        Active
      </button>
      <button
        onClick={() => {
          handleButtonClick(2, "deactive");
          setMessageBoard(false);
          setErrorTabEnable(false);
        }}
        className={`error-button ${
          toggleOption[2] === "deactive" ? "clicked" : ""
        }`}
        disabled={selectedOptions[2]}
      >
        Deactive
      </button>
    </div>
    <div className="error-message-head2">
      Continue with Troubleshooting Steps
    </div>
  </div>
  )
}

SectionTwo.propTypes = {

}

export default SectionTwo

